(() => {
  async function fetchPage(url) {
    const response=await fetch(url,{signal:AbortSignal.timeout(20000)});
    if(!response.ok)throw Error('Catalogue indisponible');
    const doc=new DOMParser().parseFromString(await response.text(),'text/html');
    const products=doc.querySelector('.glaam-builder__catalog');
    const pagination=doc.querySelector('.glaam-builder__catalog-pagination');
    if(!products||!pagination)throw Error('Page de catalogue incomplète');
    return {products:JSON.parse(products.textContent),next:JSON.parse(pagination.textContent).next};
  }
  function create({catalog,next,baseUrl,onPage=()=>{},request=fetchPage}) {
    const base=new URL(baseUrl),seen=new Set(catalog.map(product=>String(product.id))),visited=new Set();
    let pending=null;
    function pageUrl(value){
      const source=new URL(value,base);
      if(source.origin!==base.origin)throw Error('Adresse de catalogue invalide');
      source.pathname=base.pathname;
      for(const key of ['preview_theme_id','variant'])if(base.searchParams.has(key))source.searchParams.set(key,base.searchParams.get(key));
      source.searchParams.delete('sections');source.searchParams.set('section_id','glaam-catalog-page');
      return source.href;
    }
    async function loadAll(){
      if(pending)return pending;
      pending=(async()=>{
        while(next){
          const url=pageUrl(next);
          if(visited.has(url))throw Error('Pagination du catalogue invalide');
          const data=await request(url);
          if(!Array.isArray(data.products)||!(data.next==null||typeof data.next==='string'))throw Error('Page de catalogue invalide');
          for(const product of data.products){if(!product||product.id==null)throw Error('Produit du catalogue invalide');}
          for(const product of data.products){const key=String(product.id);if(!seen.has(key)){seen.add(key);catalog.push(product);}}
          visited.add(url);next=data.next;onPage();
        }
        return catalog;
      })();
      try{return await pending;}finally{pending=null;}
    }
    return {loadAll};
  }
  window.GlaamCatalogLoader={create};
})();
